import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, LineIcon, LineShareButton, TwitterIcon, TwitterShareButton } from 'react-share';
import { APP_URL } from 'src/constants';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

const WidgetShare = ({ link, eventDataLayer }) => {
  const shareLink = `${APP_URL}${link}`;
  const SOCIAL_SHARE = [
    {
      id: 1,
      name: 'facebook',
      icon: (
        <FacebookShareButton url={shareLink}>
          <FacebookIcon size={36} round={true} />
        </FacebookShareButton>
      )
    },
    {
      id: 2,
      name: 'twitter',
      icon: (
        <TwitterShareButton url={shareLink}>
          <TwitterIcon size={36} round={true} />
        </TwitterShareButton>
      )
    },
    {
      id: 3,
      name: 'line',
      icon: (
        <LineShareButton url={shareLink}>
          <LineIcon size={36} round={true} />
        </LineShareButton>
      )
    },
    {
      id: 4,
      name: 'email',
      icon: (
        <EmailShareButton url={shareLink}>
          <EmailIcon size={36} round={true} />
        </EmailShareButton>
      )
    }
  ];
  return (
    <div className='widget-social-share'>
      <ul>
        {SOCIAL_SHARE.map((item, index) => (
          <li
            key={index}
            className={`--${item.name}`}
            //! DATALAYER
            onClick={() =>
              sendDataLayerGlobal({
                ...eventDataLayer,
                data: {
                  ...eventDataLayer.data,
                  title: item.name,
                  index: index + 1
                }
              })
            }
          >
            {item.icon}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WidgetShare;
